import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';

import Global from '../../../../store/global-selectors';
import {
  exportBatchShipmentsRequest as exportShipmentsRequestAction,
  customExportBatchShipmentsRequest,
  openExportBatchShipmentsModal,
} from '../../../../store/export/shipments/export-shipments.actions';
import { ExportOptions } from '../enums/export-options-enum';
import { DefaultExportFormat } from '../enums/default-export-format';

import { ExportRecordsContainer } from './export-records-container';

const ExportRecordsModalWrapper = ({ modalFrameworkMethods, isOrdersGridShipmentMode, intl }) => {
  const [shipmentExportType, setShipmentExportType] = useState(ExportOptions.SHIPMENT);
  const batch = useSelector((state) => Global.selectBatchDetailsBatch(state)) || {};
  const { fulfillmentPlanSetId } = batch;
  const numberRecordsInView = useSelector((state) => Global.selectShipmentsGridTotalRecords(state));
  const selectedOrderIds = useSelector((state) => Global.selectSelectedOrdersIds(state));
  const selectedFulfillmentIds = useSelector((state) => Global.selectSelectedShipmentsSelectedShipmentIds(state));
  const selectedIds = isOrdersGridShipmentMode ? selectedOrderIds : selectedFulfillmentIds;
  const numberRecordsSelected = (selectedIds || []).length;
  const recordExportType = ExportOptions.SHIPMENT_RECORD_EXPORT;
  const dispatch = useDispatch();
  const { closeModal } = modalFrameworkMethods;

  const onInitiateExport = useCallback(
    (viewRecordsOrSelectedRecords, primaryRecordsOrLineItems, selectedExportFormatTypeId) => {
      if (selectedExportFormatTypeId === DefaultExportFormat.extractId) {
        dispatch(exportShipmentsRequestAction(viewRecordsOrSelectedRecords, primaryRecordsOrLineItems, intl));
        closeModal();
        return;
      }
      dispatch(
        customExportBatchShipmentsRequest(
          viewRecordsOrSelectedRecords,
          selectedExportFormatTypeId,
          selectedIds,
          fulfillmentPlanSetId,
          intl,
        ),
      );
      closeModal();
    },
    [dispatch, selectedIds, fulfillmentPlanSetId, intl, closeModal],
  );

  const updateShipmentExportType = useCallback(
    (primaryRecordsOrLineItems) => {
      if (primaryRecordsOrLineItems === ExportOptions.EXPORT_PRIMARY_RECORDS) {
        setShipmentExportType(ExportOptions.SHIPMENT);
        return;
      }
      setShipmentExportType(ExportOptions.SHIPMENT_LINE_ITEM);
    },
    [setShipmentExportType],
  );

  return (
    <ExportRecordsContainer
      exportTypeEnum={shipmentExportType}
      modalFrameworkMethods={modalFrameworkMethods}
      numberRecordsInView={numberRecordsInView}
      numberRecordsSelected={numberRecordsSelected}
      onInitiateExport={onInitiateExport}
      onUpdateExportType={updateShipmentExportType}
      recordExportType={recordExportType}
      retryAction={openExportBatchShipmentsModal}
    />
  );
};

ExportRecordsModalWrapper.propTypes = {
  modalFrameworkMethods: PropTypes.object.isRequired,
  isOrdersGridShipmentMode: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
};

export const ExportBatchShipmentsContainer = injectIntl(ExportRecordsModalWrapper);
